export default __webpack_public_path__ + "static/media/protein.694c8db4.png";